import {
  BUFFER_HOME_TASK_KEY,
  BUFFER_HOME_TASK_STATUS,
  useBufferHomeChecklist,
} from './useBufferHomeChecklist'
import type {
  BufferHomeTaskKey,
  BufferHomeTaskStatus,
} from './useBufferHomeChecklist'
import { useDismissBufferHomeTask } from './useDismissBufferHomeTask'
import { useMarkBufferHomeTaskComplete } from './useMarkBufferHomeTaskComplete'

export type TaskCardStatusResult = {
  status: BufferHomeTaskStatus
  /**
   * True while we have not yet observed the underlying data for this card.
   * Distinct from `pending`: `pending` means the user has not acted on the
   * task; `loading` means we do not yet know whether they have.
   */
  loading: boolean
  markComplete: () => void
  /**
   * Dismiss is only wired for cards that expose the affordance in the UI
   * (currently Invite Team). Other cards still receive the callback but the
   * UI does not render a dismiss control.
   */
  dismiss: () => void
}

function useTaskStatus(taskKey: BufferHomeTaskKey): TaskCardStatusResult {
  const { tasks, loading } = useBufferHomeChecklist()
  const { markComplete } = useMarkBufferHomeTaskComplete()
  const { dismiss } = useDismissBufferHomeTask()

  const status: BufferHomeTaskStatus =
    tasks.find((task) => task.taskKey === taskKey)?.status ??
    BUFFER_HOME_TASK_STATUS.Pending

  return {
    status,
    loading,
    markComplete: () => markComplete(taskKey),
    dismiss: () => dismiss(taskKey),
  }
}

export function useConnectChannelStatus(): TaskCardStatusResult {
  return useTaskStatus(BUFFER_HOME_TASK_KEY.ConnectChannel)
}

export function useInviteTeamStatus(): TaskCardStatusResult {
  return useTaskStatus(BUFFER_HOME_TASK_KEY.InviteTeam)
}

export function useCreateFirstPostStatus(): TaskCardStatusResult {
  return useTaskStatus(BUFFER_HOME_TASK_KEY.CreateFirstPost)
}

export function useTryBufferApiStatus(): TaskCardStatusResult {
  return useTaskStatus(BUFFER_HOME_TASK_KEY.TryBufferApi)
}
